import { Table, Input, Button, Modal, DatePicker, Select } from "antd";
import React, { useEffect, useState } from "react";
import { httpGet, httpUrl, httpPost } from "../../api/httpClient";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ko_KR";
import excelPng from "../../img/excel.png";
import { utils, writeFile } from "xlsx";
import { filterCodeWithdraw, statusCode } from "../../lib/util/codeUtil";
import { comma } from "../../lib/util/numberUtil";
import SelectBox from "../../components/common/SelectBox";

const Search = Input.Search;
const Option = Select.Option;
const { RangePicker } = DatePicker;
const now = new Date();

const WithdrawList = () => {
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const dte = 1000000000;
    const [type, setType] = useState(0);
    const [list, setList] = useState([]);
    const [searchStr, setSearchStr] = useState("");    
    const [searchFilter, setSearchFilter] = useState("ALL");
    const [checkedStatus, setCheckedStatus] = useState("ALL");
    const [date, setDate] = useState({
        start: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD")
      });

    useEffect(() => {
        getList();
    },[date.start, date.end, pagination.current, pagination.pageSize, searchStr]);


    const onSearch = async (value) => {
        setSearchStr(value)
        getList();
    };

    const onSelectStatus = (value) => {
        setCheckedStatus(value);
    };

    const onSelectFilter = (value) => {
        setSearchFilter(value);
    };


    const getList = async () => {
        const pageSize = pagination.pageSize;
        const pageNum = pagination.current;
        const endDate = moment(date.end).add(1, 'd').format("YYYY-MM-DD");
        const res = await httpGet(httpUrl.transferLogList, [searchStr, searchFilter, date.start, endDate, pageNum, pageSize, "I2E", checkedStatus], {})
        if (!res) {
            console.log(`getListAsync failed. result: ${res.result}`);
            return;
        }
        setList(res.data.list);
        setPagination({
            ...pagination,
            total: res.data.totalCount
        })
    };

    const handleTableChange = (page) => {
        if (page.current !== pagination.current) {
            setPagination({
                ...pagination,
                current: page.current
            });
        } else if (page.pageSize !== pagination.pageSize) {
            setPagination({
                ...pagination,
                current: 1,
                pageSize: page.pageSize
            });
        }
    };
    
    const columns = [
        {
            title: "거래번호",
            dataIndex: "idx",
            className: "column-center",
        },
        {
            title: "일시",
            dataIndex: "createDate",
            className: "column-center",
            render: (data) => <div>{moment(data).format("YYYY-MM-DD HH:mm:ss")}</div>
        },
        {
            title: "유저키",
            dataIndex: "from",
            className: "column-center",
        },
        {
            title: "출금키",
            dataIndex: "withdrawKey",
            className: "column-center",
        },
        {
            title: "주소",
            dataIndex: "to",
            className: "column-center",
            render: (data) => 
            <a
                className="alink"
                target='_blank'
                href={"https://bscscan.com/address/"+data}
            >
                {data}
            </a>
        },
        {
            title: "TXID",
            dataIndex: "txid",
            className: "column-center",
            render: (data) => 
                <a
                    className="alink"
                    target='_blank'
                    href={"https://bscscan.com/tx/"+data}
                >
                    {data}
                </a>
        },
        {
            title: "구분",
            dataIndex: "coinType",
            className: "column-center",
        },
        {
            title: "수량(USDT)",
            dataIndex: "amount",
            className: "column-center",
            render: (data) => <div>{comma(data/dte)}</div>
        },
        {
            title: "상태",
            dataIndex: "status",
            className: "column-center",
            render: (data) => <div>{statusCode[data] || data}</div>
        },
    ];

    const reset =() =>{
        setType(0)
        setDate({
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
        setSearchStr("");
        setSearchFilter("ALL");
        setCheckedStatus("ALL");
    };

    const changeDate =(type) =>{
    if (type ==='today'){
        setType(0)
        setDate({
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    } else if (type === 'week'){
        setType(1)
        setDate({
            start: moment().add(-7, 'd').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    }else if (type === 'threeMonth'){
        setType(2)
        setDate({
            start:  moment().add(-3, 'M').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    }else{
        setType(3)
        setDate({
            start: moment('2023-01-01').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
        }

    };

    const onChangeRangePicker = async (e, selectDate, value) => {
        setType(4)
        setDate({
            start: moment(selectDate[0]).format('YYYY-MM-DD'),
            end: moment(selectDate[1]).format('YYYY-MM-DD')
        })
        getList();
    };

    const disabledDate = (current) => {
    return current && current > moment().endOf('day');
    };

    const onDownload = () => {
        httpGet(httpUrl.transferLogExcelList, [
            searchStr, 
            searchFilter,
            date.start,
            moment(date.end).add(1, 'd').format("YYYY-MM-DD"),
            "I2E", 
            checkedStatus
        ],{}).then((res) => {
            const excelJson = parseExcelJson(res.data.list);
            const ws = utils.json_to_sheet(excelJson, { skipHeader: true });
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "sheet1");
            writeFile(wb, "출금_내역.xlsx");
        });
    };

    const parseExcelJson = (data) => {
        let result = [
          {
            idx: '거래번호',
            createDate: '일시',
            userKey: '유저키',
            withdrawKey: '출금키',
            address:'주소',
            txid: 'TXID',
            coinType: '구분',
            amount: '수량(USDT)',
            status: '상태'
          },
        ];
        data.forEach((item) => {
          result.push({
            idx: item.idx,
            createDate: moment(item.createDate).format("YYYY-MM-DD HH:mm:ss"),
            userKey: item.from,
            withdrawKey: item.withdrawKey,
            address: item.to,
            txid: item.txid,
            coinType: item.coinType,
            amount: item.amount + `(USDT)`,
            status: item.status
          });
        });
    
        return result;
      };
    
    return (
        <div className="main">
        <div className="main-title">
            출금 내역
        </div>
            <div className="top-bar">
                    <div id="selectBox">
                            <Button className={type === 0 && "active"} onClick={()=>changeDate('today')}>
                                금일
                            </Button>
                            <Button  className={type === 1 && "active"} onClick={()=>changeDate('week')}>
                                1주일
                            </Button>
                            <Button className={type === 2 && "active"} onClick={()=>changeDate('threeMonth')}>
                                3개월
                            </Button>
                            <Button className={type === 3 && "active"} onClick={()=>changeDate('all')}>
                                전체
                            </Button>
                            <p>
                    <RangePicker
                        style={{padding:5, borderRadius:5, marginRight:10,  border:'1px solid #888',height:32}}
                        locale={locale}
                        format={"YYYY-MM-DD"}
                        allowClear={false}
                        picker="date"
                        value={[
                        moment(date.start, "YYYY-MM-DD"),
                        moment(date.end, "YYYY-MM-DD"),
                        ]}
                        onChange={onChangeRangePicker}
                        disabledDate={disabledDate}
                    />
                    </p>
                    {/* <SelectBox
                        name="searchType"
                        className="memo-select" 
                        style={{width:100}}
                        placeholder={statusCode['ALL']}
                        code={Object.keys(statusCode)}
                        codeString={statusCode}
                        onChange={(value) => {onSelectStatus(value)}}
                        value={checkedStatus}
                    /> */}
                    <div className="memo-select-sub">
                        <SelectBox
                            name="searchType"
                            className="memo-select" 
                            style={{width:100}}
                            placeholder={filterCodeWithdraw['ALL']}
                            code={Object.keys(filterCodeWithdraw)}
                            codeString={filterCodeWithdraw}
                            onChange={(value) => {onSelectFilter(value)}}
                            value={searchFilter}
                        />
                    </div>
                    <Search
                        placeholder="검색어를 입력하세요"
                        className="search-input"
                        enterButton
                        allowClear
                        onSearch={onSearch}
                        value={searchStr}
                        onChange={(e)=>{
                            setSearchStr(e.target.value.trim());
                        }}
                    />
                </div>
                <Button onClick={()=>reset()}>
                   초기화
                </Button>
            </div>
           <div className="top-table">
                <div className="top-table-container">
                        <div>
                        총 <span> {comma(pagination.total)}</span>건이 검색되었습니다.
                        </div>
                        <div>
                        <Button className="download-btn"
                            onClick={() => onDownload()}
                        > 
                        <div>
                            <img src={excelPng} alt="" />다운로드
                        </div>
                        </Button>
                        </div>
                 </div>

                <Table
                    rowKey={(record) => record.idx}
                    dataSource={list}
                    columns={columns}
                    pagination={pagination}
                    onChange={handleTableChange}
                />
             </div>
        </div>
    );

}

export default WithdrawList;
